import Auth from '@client/models/store/auth';
import {Logger, Category} from '@simpleinvest/front-end-logger';
import {logout as awsLogout} from '@simpleinvest/front-end-auth';
import windowHelper from '@client/util/windowHelper';

const logger = new Logger({
  category: Category.Authentication,
  fileName: 'auth.js',
});

const stateObj = () => new Auth();

const getters = {
  emailToRecoverPasswordFor: (state) => state.emailToRecoverPasswordFor,
};

const redirectionURL = (logout) => {
  const {VUE_APP_COGNITO_DOMAIN, VUE_APP_COGNITO_CLIENT_ID} = process.env;
  const logoutUri = logout ? `&logout_uri=${logout.url}` : '';

  return [`https://${VUE_APP_COGNITO_DOMAIN}/logout?client_id=${VUE_APP_COGNITO_CLIENT_ID}${logoutUri}`];
};
const actions = {
  async logout({dispatch}, {redirect = true, timeout = false} = {}) {
    try {
      await awsLogout();

      if (window.localStorage.getItem('SSO_PROVIDER')) {
        window.localStorage.removeItem('SSO_PROVIDER');
        await dispatch('ssoLogout');

        return;
      }

      if (redirect) {
        let replaceUrl = window.BASE_URL.replace(/\/?$/, '/');

        if (timeout) {
          replaceUrl += '?inactive=true';
        }

        windowHelper.location.assign(replaceUrl);
      }
    } catch (error) {
      logger.addBreadcrumb({
        callingFuncName: 'logout',
        message: `Logout error caught`,
      });
      logger.logException({error});
    }
  },

  ssoLogout({rootGetters}) {
    const {header = []} = rootGetters['settings/enterprise'];
    const enterpriseLinksArray = header.rightItems;

    const logout = (enterpriseLinksArray || []).find((item) => item.name.toLowerCase() === 'log out');
    // Changes for fortify scan open redirect vulnerability
    const urlList = redirectionURL(logout);

    windowHelper.location.assign(urlList[0]);
  },
  setEmailToRecoverPasswordFor({commit}, emailToRecoverPasswordFor) {
    commit('SET_EMAIL_TO_RECOVER_PASSWORD_FOR', emailToRecoverPasswordFor);
  },
};

const mutations = {
  SET_EMAIL_TO_RECOVER_PASSWORD_FOR(state, emailToRecoverPasswordFor) {
    state.emailToRecoverPasswordFor = emailToRecoverPasswordFor;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
